import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { exampleTram } from './tram/tram';

export function initializeIcons(library: FaIconLibrary) {
    // it is necessary to import only icons needed by the project
    // to emprove performance on build size
    library.addIconPacks(fas, far, fab);

    //Example custom icons
    library.addIcons(exampleTram);
}